<template>
  <div
    class="patient-insider-hero"
    :style="{
      backgroundColor: backgroundColor,
      backgroundImage: `url(${backgroundImage})`,
    }"
  >
    <p
      class="patient-insider-hero__intro-text"
    >
      <span
        class="patient-insider-hero__super-heading"
        :style="{ color: backgroundColor }"
      >{{ superHeading }}</span>
      <span class="patient-insider-hero__greeting">{{ greeting }}</span>
      <span class="patient-insider-hero__name">{{ name }}</span>
      <span class="patient-insider-hero__intro-line-1">{{ line1 }}</span>
      <span class="patient-insider-hero__intro-line-2">{{ line2 }}</span>
    </p>
    <img
      class="patient-insider-hero__image"
      :src="mainImageUrl"
      :alt="mainImageAlt"
    >
  </div>
</template>

<script>
export default {
  name: 'PatientInsiderHero',
  props: {
    backgroundColor: {
      type: String,
      default: '',
    },
    backgroundMedia: {
      type: Array,
      default: () => [],
    },
    greeting: {
      type: String,
      default: '',
    },
    line1: {
      type: String,
      default: '',
    },
    line2: {
      type: String,
      default: '',
    },
    mainMedia: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: '',
    },
    superHeading: {
      type: String,
      default: '',
    },
  },
  computed: {
    backgroundImage() {
      return this.backgroundMedia
        && this.backgroundMedia[0]
        && this.backgroundMedia[0].url;
    },
    mainImageUrl() {
      return this.mainMedia
        && this.mainMedia[0]
        && this.mainMedia[0].url;
    },
    mainImageAlt() {
      return this.mainMedia
        && this.mainMedia[0]
        && this.mainMedia[0].alt;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_patient-insider-hero';
</style>
